import { LoopSettingProps } from './LoopSetting.types'

const useLoopSetting = (props: LoopSettingProps) => props

export default useLoopSetting
